import { immerable } from "immer";

export class CreateProviderSetupRequest {
  labName: string | null = null;
  labDescription: string | null = null;
  labEmail: string | null = null;
  storageId: number | null = 0;

  constructor(init?: Partial<CreateProviderSetupRequest>) {
    Object.assign(this, init);
  }
}

export class CreateProviderSetupFullRequest {
  [immerable] = true;
  labName: string | null = null;
  labEmail: string | null = null;
  firstName: string | null = null;
  lastName: string | null = null;
  copyPermsFromGroupId: number | null = null;
  copyPermsFromRoleId: number | null = null;
  disableAffinityCheck: boolean = false;

  constructor(init?: Partial<CreateProviderSetupFullRequest>) {
    Object.assign(this, init);
  }
}
